import {useContext} from "react";

import {APIPostOrderLinkedMessaging} from "../../api/orders/OrdersMessaging";
import {APISetOrderStage} from "../../api/orders/Orders";

import { OrderTenderAction } from "./orderTenderAction";

import {OrderContext} from "../../context/OrderContext";
import {UserContext} from '../../context/UserContext';


export const OrderActions = () => {
    const {order, getOrder, userStatus, orderEdit, setOrderEdit, setOpenOrderStartReviewModal} = useContext(OrderContext);
    const { user } = useContext(UserContext);

    const startEdit = async () => {
        setOrderEdit(true)
    }

    const startWork = async () => {
        const messageData = {
            ordersId : order?.id,
            linkId : order?.id,
            linkType : "progressUpdate",
            createdByUser : user?.id,
            createdByUserName : user?.name,
            createdByCompany : user?.companyId,
            createdByCompanyName : user?.companyId,
            message : "Es wurde mit der Bearbeitung des Auftrags gestartet",
            orderCompanyUser: order?.createdByUser,
            orderCompany: order?.createdByCompany,
            contractedCompany: order?.contractedCompany,
            planId: order?.planId,
        }
        await Promise.all([
            APIPostOrderLinkedMessaging({messageData, companyId: user?.companyId}),
            APISetOrderStage({orderId: order?.id, stage: "inDevelopment", companyId: user?.companyId})
        ]);
        await getOrder()
    }

    const stopWork = async () => {
        const messageData = {
            ordersId : order?.id,
            linkId : order?.id,
            linkType : "progressUpdateStageBack",
            createdByUser : user?.id,
            createdByUserName : user?.name,
            createdByCompany : user?.companyId,
            createdByCompanyName : user?.companyId,
            message : "Die bearbeitung des Auftrags wurde Pausiert.",
            orderCompanyUser: order?.createdByUser,
            orderCompany: order?.createdByCompany,
            contractedCompany: order?.contractedCompany,
            planId: order?.planId,
        }
        await Promise.all([
            APIPostOrderLinkedMessaging({messageData, companyId: user?.companyId}),
            APISetOrderStage({orderId: order?.id, stage: "contracted", companyId: user?.companyId})
        ]);
        await getOrder()
    }

    const cancelReview = async () => {
        const messageData = {
            ordersId : order?.id,
            linkId : order?.id,
            linkType : "progressUpdateStageBack",
            createdByUser : user?.id,
            createdByUserName : user?.name,
            createdByCompany : user?.companyId,
            createdByCompanyName : user?.companyId,
            message : "Die Abnahme des Auftrags wurde vorzeitig Zurückgezogen.",
            orderCompanyUser: order?.createdByUser,
            orderCompany: order?.createdByCompany,
            contractedCompany: order?.contractedCompany,
            planId: order?.planId,
        }

        await Promise.all([
            APIPostOrderLinkedMessaging({messageData, companyId: user?.companyId}),
            APISetOrderStage({orderId: order?.id, stage: "inDevelopment", companyId: user?.companyId})
        ]);
        await getOrder();
    }

    const getActions = () => {
        if (userStatus === 'orderOwner') {
            if (order.stage === 'draft') {
                return (
                    <>
                        <button 
                            type="button" 
                            onClick={startEdit}  
                            className="sm:my-0 border w-full sm:w-auto border-gray-500 block items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-inset hover:bg-gray-50"
                            disabled={orderEdit}
                        >
                            Bearbeiten
                        </button>
                        <OrderTenderAction />
                    </>
                )
            } else if (order.stage === 'inTender') {
                return (
                    <OrderTenderAction />
                )
            } 
    
        } else if (userStatus === 'tenderOwner') {
            if (order.stage === 'contracted') {
                return (
                    <div>
                        <button 
                            onClick={() => {startWork()}}
                            type="button" 
                            className="ml-3 inline-flex items-center rounded-md border-2 border-gray-900 bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm hover:text-gray-600  hover:border-gray-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                        >
                            Bearbeitung starten
                        </button>
                    </div>
                );
            } else if (order.stage === 'inDevelopment') {
                return (
                    <div>
                        <button 
                            onClick={() => {stopWork()}} 
                            type="button" 
                            className="ml-3 inline-flex items-center rounded-md  px-3 py-2 text-sm font-semibold text-red border-red border-2"
                        >
                            Bearbeitung pausieren
                        </button>
                        <button 
                            onClick={() => {setOpenOrderStartReviewModal(true)}} 
                            type="button"
                            className="ml-3 inline-flex items-center rounded-md border-2 border-gray-900 bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm hover:text-gray-600  hover:border-gray-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                        >
                            Abnahme starten
                        </button>
                    </div>
                );
            } else if (order.stage === 'inReview') {
                return (
                    <div>
                        <button 
                            onClick={() => {cancelReview()}} 
                            type="button" 
                            className="ml-3 inline-flex items-center rounded-md  px-3 py-2 text-sm font-semibold text-red border-red border-2"
                        >
                            Abnahme zurückziehen
                        </button>
                    </div>
                );
            }
                
        } else {
    
        }
        return null;
    }



    return (
        <div className={"sm:flex gap-2 items-end mt-4 sm:mt-0 sm:justify-end"}>
            {getActions()}
        </div>
    )
}